export const state = {
  cids: [],
  cid: {}
}
